import React from "react"
import avatar from "avatar/leri-sad.svg"

const LeriSad = (props) => <img src={avatar} className="avatar" {...props} />

export default LeriSad
